export default "__VITE_ASSET___fE8tm4M__"